if (!customElements.get("sticky-atc-bar")) {
  customElements.define(
    "sticky-atc-bar",
    class StickyAtcBar extends HTMLElement {
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      connectedCallback() {
        this.container = this.closest(".sticky-atc-bar");
        this.mainProduct = document.querySelector(
          "product-info[id^='MainProduct']",
        );
        this.disableDefaultVariant =
          this.mainProduct?.dataset.disableDefaultSelectVariant === "true";
        this.productFormActions =
          (this.mainProduct &&
            this.mainProduct.querySelector('[id^="ProductSubmitButton-"]')) ||
          document.querySelector('[id^="ProductSubmitButton-"]');

        this.sizeIndex = Number(this.dataset.sizeOptionIndex || 0);
        this.variantData = this.getVariantData();
        this.idInput = this.querySelector('[name="id"]');
        this.sizeEl = this.querySelector("[data-sticky-size]");

        this.quantityInput =
          this.mainProduct &&
          this.mainProduct.querySelector("quantity-input input");

        this.mainVariantPicker =
          this.mainProduct?.querySelector("variant-picker");

        if (this.mainVariantPicker) {
          this.mainVariantPicker.addEventListener("change", () => {
            this.syncVariantFromMainOptions();
          });
        }
        this.productForm = this.querySelector("form");
        this.stickyQuantityInput = this.querySelector("[data-sticky-quantity]");

        if (this.productForm) {
          this.productForm.addEventListener(
            "submit",
            () => {
              const quantityInput = this.mainProduct?.querySelector(
                '.quantity__input[name="quantity"]',
              );

              if (this.stickyQuantityInput) {
                this.stickyQuantityInput.value = quantityInput?.value || 1;
              }
            },
            { capture: true },
          );
        }

        this.optionSelects = Array.from(
          this.querySelectorAll("[data-option-index]"),
        );

        this.optionSelects.forEach((select) =>
          select.addEventListener("change", () => this.onOptionChange()),
        );

        const changeSelectionBtn = this.querySelector(
          "[data-change-selection]",
        );
        if (changeSelectionBtn) {
          changeSelectionBtn.addEventListener("click", () => {
            const variantPicker =
              this.mainProduct &&
              this.mainProduct.querySelector("variant-picker");
            (
              variantPicker ||
              this.productFormActions ||
              document.body
            ).scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          });
        }

        this.init();
        this.syncWithMainProductForm();
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.container.querySelector('[type="application/json"]')
              .textContent,
          );
        return this.variantData;
      }

      onOptionChange() {
        const selected = this.optionSelects.map((select) => select.value);
        const variant = this.variantData.find((v) =>
          v.options.every((option, index) => option === selected[index]),
        );
        this.currentVariant = variant;

        const mainVariantPicker =
          this.mainProduct && this.mainProduct.querySelector("variant-picker");
        if (mainVariantPicker && variant) {
          Array.from(
            mainVariantPicker.querySelectorAll(
              "select, .variant-picker__option-values",
            ),
            (element, index) => {
              const variantOptionVal = variant.options[index];
              switch (element.tagName) {
                case "SELECT":
                  element.value = variantOptionVal;
                  break;
                case "DIV":
                  Array.from(element.querySelectorAll("input")).forEach(
                    (radio) => {
                      if (radio.value === variantOptionVal) {
                        radio.checked = true;
                      }
                    },
                  );
                  break;
              }
            },
          );
          mainVariantPicker.dispatchEvent(new Event("change"));
        }

        this.render(variant);
      }

      init() {
        this.trigger = this.productFormActions;

        if (!this.trigger) {
          // If we cannot find the real ATC button, fail closed.
          // Don't show the sticky bar automatically.
          this.container.classList.remove("sticky-atc-bar--show");

          console.warn(
            "[sticky-atc-bar] Main product Add to Cart button could not be found.",
          );

          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // User is currently looking at the normal ATC.
                this.container.classList.remove("sticky-atc-bar--show");
                return;
              }

              const hasScrolledPastAtc = entry.boundingClientRect.bottom <= 0;

              this.container.classList.toggle(
                "sticky-atc-bar--show",
                hasScrolledPastAtc,
              );
            });
          },
          { threshold: 0 },
        );
        this.observer.observe(this.trigger);
      }

      render(variant) {
        this.currentVariant = variant;
        if (!variant) {
          if (this.idInput) this.idInput.value = "";
          this.updateButton(true, "", true);
          return;
        }
        if (this.idInput) this.idInput.value = variant.id;
        if (this.sizeEl) {
          this.sizeEl.textContent = variant.options[this.sizeIndex];
        }
        this.updatePrice();

        const checkAgainstInventory =
          variant.inventory_management === "shopify" &&
          variant.inventory_policy !== "continue";

        const quantityRuleSoldOut =
          checkAgainstInventory &&
          variant.quantity_rule?.min > variant.inventory_quantity;

        this.updateButton(
          !variant.available || quantityRuleSoldOut,
          window.FoxThemeStrings.soldOut,
          false,
        );
      }

      updateButton(disable = true, text, modifyClass = true) {
        const buttons = this.querySelectorAll('[name="add"]');
        buttons.forEach((addButton) => {
          const addButtonText = addButton.querySelector("span:not(.f-icon)");
          if (disable) {
            addButton.setAttribute("disabled", "disabled");
            if (text && addButtonText) addButtonText.textContent = text;
          } else {
            addButton.removeAttribute("disabled");
            if (addButtonText) {
              addButtonText.textContent = window.FoxThemeStrings.addToCart;
            }
          }
        });
      }

      updatePrice() {
        const classes = {
          onSale: "f-price--on-sale",
          soldOut: "f-price--sold-out",
        };
        const money_format = window.FoxThemeSettings.money_format;
        const { compare_at_price, price, unit_price, unit_price_measurement } =
          this.currentVariant;
        const onSale = compare_at_price && compare_at_price > price;
        const soldOut = !this.currentVariant.available;

        this.querySelectorAll(".f-price").forEach((priceWrapper) => {
          const salePrice = priceWrapper.querySelector(".f-price-item--sale");
          const compareAtPrice = priceWrapper.querySelectorAll(
            ".f-price-item--regular",
          );
          const unitPrice = priceWrapper.querySelector("[data-unit-price]");

          if (unitPrice) {
            if (unit_price && unit_price_measurement) {
              unitPrice.classList.remove("f-hidden");

              unitPrice.innerHTML = `<span>${formatMoney(unit_price, money_format)}</span>/<span data-unit-price-base-unit>${getBaseUnit(
                this.currentVariant,
              )}</span>`;
            } else {
              unitPrice.classList.add("f-hidden");
            }
          }
          priceWrapper.classList.toggle(classes.onSale, !!onSale);
          priceWrapper.classList.toggle(classes.soldOut, soldOut);
          priceWrapper.classList.remove("visibility-hidden");

          if (salePrice) salePrice.innerHTML = formatMoney(price, money_format);

          if (compareAtPrice.length && onSale) {
            compareAtPrice.forEach(
              (item) =>
                (item.innerHTML = formatMoney(compare_at_price, money_format)),
            );
          } else {
            compareAtPrice.forEach(
              (item) => (item.innerHTML = formatMoney(price, money_format)),
            );
          }
        });
      }

      syncWithMainProductForm() {
        if (!this.mainProduct) return;

        this.mainProduct.addEventListener("change", (event) => {
          if (!event.target.closest("variant-picker")) return;

          this.syncVariantFromMainOptions();
        });

        const disableDefaultVariant =
          this.mainProduct.dataset.disableDefaultSelectVariant === "true";

        if (disableDefaultVariant) {
          if (this.idInput) this.idInput.value = "";
          this.updateButton(true, "", true);
          this.container.classList.add("f-hidden");
          return;
        }

        this.syncVariantFromMainOptions();
      }

      syncVariantFromMainOptions() {
        const mainVariantPicker =
          this.mainProduct?.querySelector("variant-picker");

        if (!mainVariantPicker) return;

        const optionGroups = mainVariantPicker.querySelectorAll(
          "select, .variant-picker__option-values",
        );

        const selectedOptions = Array.from(optionGroups).map((group) => {
          if (group.tagName === "SELECT") {
            return group.value;
          }

          const checked = group.querySelector("input:checked");
          return checked?.value;
        });

        if (selectedOptions.some((option) => !option)) {
          if (this.idInput) this.idInput.value = "";

          this.updateButton(true, "", true);
          this.container.classList.add("f-hidden");
          return;
        }

        const variant = this.variantData.find((variant) =>
          variant.options.every(
            (option, index) => option === selectedOptions[index],
          ),
        );

        if (!variant) {
          if (this.idInput) this.idInput.value = "";

          this.updateButton(true, "", true);
          this.container.classList.add("f-hidden");
          return;
        }

        if (!variant) {
          this.container.classList.add("f-hidden");
          return;
        }

        this.optionSelects.forEach((select, index) => {
          select.value = variant.options[index];
        });

        this.container.classList.remove("f-hidden");
        this.render(variant);
      }
    },
  );
}
